import { livePhotos } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function LiveSection() {
  return (
    <section id="live" className="w-full bg-background-100 py-14 md:py-20 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            kicker="LIVE 实时"
            title="现场直击 · 正在发生"
            desc="各路机位随时回传，路透照与活动生图按事件持续上新。想看哪个现场，点开就看直出原图。"
          />
          <a
            href="#events"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById("events")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
          >
            更多热门事件 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {livePhotos.map((p) => (
            <article
              key={p.id}
              className="group relative rounded-lg overflow-hidden bg-background-200 cursor-pointer"
              onClick={() => window.dispatchEvent(new CustomEvent("chigua:toast", { detail: `正在整理「${p.title}」的高清生图…` }))}
            >
              <div className="relative aspect-[3/4] w-full overflow-hidden">
                <img
                  src={p.img}
                  alt={`${p.scene}${p.title}现场实拍图`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent"></div>

                <span
                  className={`absolute top-3 left-3 flex items-center gap-1 px-2 py-0.5 rounded text-[10px] font-bold text-background-50 whitespace-nowrap ${
                    p.hot === "LIVE" ? "bg-primary-500" : p.hot === "HOT" ? "bg-accent-600" : "bg-foreground-950/70"
                  }`}
                >
                  {p.hot === "LIVE" && <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-pulse"></span>}
                  {p.hot}
                </span>
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded text-[10px] text-background-100 bg-foreground-950/60 whitespace-nowrap">
                  {p.time}
                </span>

                <div className="absolute inset-x-0 bottom-0 p-3">
                  <p className="text-xs text-accent-200 font-medium">{p.scene}</p>
                  <h3 className="mt-1 text-sm font-semibold text-background-50 leading-snug line-clamp-2">{p.title}</h3>
                  <p className="mt-2 flex items-center gap-1 text-[11px] text-background-100/80">
                    <i className="ri-eye-line"></i>
                    {p.viewers}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}